export const sources={};export const img={src:"__VITE_ASSET__cLLFq7OX38PQjR0WE41fig__",w:640,h:640};export default{sources:sources,img:img};